import '../../../base_builders/vertical/rcp/rcp_base_builder';

//Its required for comments
import RcmgSpot from '../../../../assets/js/RCMG_V2/RcmgSpot.js';

import VideosInit from "../../../../assets/js/Videos/Videos";
VideosInit();

import Comments from "../../../../assets/js/Widgets/SpotIM/Comments";
Comments();

import VideoCalendarConfig from '../../../../assets/js/YCalendar/VideoCalendarConfigs';
VideoCalendarConfig();